import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./LearningStats.css";

import {
    BookOpen,
    Award,
    BarChart3,
    GraduationCap
} from "lucide-react";


const LearningStats = () => {

    /* ==============================
       USER
    ============================== */

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* ==============================
       COURSE STATUS
    ============================== */

    const [courseStatus, setCourseStatus] =
        useState(null);


    const [loading, setLoading] =
        useState(true);


    /* ==============================
       LOAD COURSE STATUS
    ============================== */

    useEffect(() => {

        if (!email) {

            setLoading(false);

            return;

        }

        loadCourseStatus();

    }, [email]);


    const loadCourseStatus = async () => {

        try {

            setLoading(true);

            const res =
                await axios.get(

                    `/api/ignite/course/status/${email}`

                );


            if (res.data.success) {

                setCourseStatus({

                    neuroPerformanceFoundational:
                        res.data.courses
                            ?.neuroPerformanceFoundational || false,

                    eyeHealthAthleticEdition:
                        res.data.courses
                            ?.eyeHealthAthleticEdition || false,

                    eyeHealthDetailed:
                        res.data.courses
                            ?.eyeHealthDetailed || false,

                    allCoursesCompleted:
                        res.data.allCoursesCompleted || false

                });

            }

        }

        catch (err) {

            console.error(

                "Learning Stats Error:",

                err

            );

        }

        finally {

            setLoading(false);

        }

    };


    /* ==============================
       LOADING
    ============================== */

    if (loading || !courseStatus) {

        return (

            <div className="learning-stats-card">

                Loading...

            </div>

        );

    }


    /* ==============================
       COURSE CALCULATION
    ============================== */

    const completedCourses = [

        courseStatus
            .neuroPerformanceFoundational,

        courseStatus
            .eyeHealthAthleticEdition,

        courseStatus
            .eyeHealthDetailed

    ].filter(Boolean).length;


    const totalCourses = 3;


    const progress =

        Math.round(

            (

                completedCourses /

                totalCourses

            ) * 100

        );


    const allCompleted =
        completedCourses === totalCourses;


    return (

        <div className="learning-stats-card">


            {/* =========================
                HEADER
            ========================= */}

            <div className="learning-header">

                <div>

                    <h2>

                        Learning Statistics

                    </h2>

                    <p>

                        Your overall learning progress.

                    </p>

                </div>

                <GraduationCap/>

            </div>


            {/* =========================
                STATISTICS
            ========================= */}

            <div className="learning-grid">


                {/* =====================
                    COURSES COMPLETED
                ===================== */}

                <div className="learning-item">

                    <BookOpen/>

                    <h3>

                        {completedCourses}

                    </h3>

                    <span>

                        Courses Completed

                    </span>

                </div>


                {/* =====================
                    TOTAL COURSES
                ===================== */}

                <div className="learning-item">

                    <Award/>

                    <h3>

                        {totalCourses}

                    </h3>

                    <span>

                        Total Courses

                    </span>

                </div>


                {/* =====================
                    COMPLETION
                ===================== */}

                <div className="learning-item">

                    <BarChart3/>

                    <h3>

                        {progress}%

                    </h3>

                    <span>

                        Completion

                    </span>

                </div>


                {/* =====================
                    STATUS
                ===================== */}

                <div className="learning-item">

                    <GraduationCap/>

                    <h3>

                        {

                            allCompleted

                                ?

                                "Completed"

                                :

                                "Learning"

                        }

                    </h3>

                    <span>

                        Current Status

                    </span>

                </div>


            </div>

        </div>

    );

};


export default LearningStats;